import {Dispatch, useCallback, useState} from "react";

type ResetStateAction = {type: "reset-state"};

export function useDraftResumeBanner(
  wasDraftRestored: boolean,
  dispatch: Dispatch<ResetStateAction>
) {
  const [formKey, setFormKey] = useState(0);
  const [showBanner, setShowBanner] = useState(wasDraftRestored);

  const handleStartFresh = useCallback(() => {
    dispatch({type: "reset-state"});
    setShowBanner(false);
    setFormKey((key) => key + 1);
  }, [dispatch]);

  return {formKey, showBanner, handleStartFresh};
}
